import styled from "styled-components";

const Card = styled.div.attrs({
  className:
    "bg-[#FFFFFF] max-w-4xl flex flex-col justify-center items-center mx-5 lg:mx-auto my-5 py-32 rounded-lg shadow-xl",
})``;

const CardContent = styled.div.attrs({
  className: "w-4/5 sm:w-3/4 md:w-1/2",
})``;

const CardTitle = styled.div.attrs({
  className: "text-[#DF6865] text-2xl font-bold self-start",
})``;

const ButtonType = styled.div.attrs({
  className: "flex flex-col justify-center items-center",
})``;

const Border = styled.div.attrs({
  className:
    "hover:border-double hover:border-2 hover:border-[#DC4F4C] w-24 sm:w-32 md:w-44 h-24 sm:h-32 md:h-44 p-1 rounded-full cursor-pointer",
})``;

const Inside = styled.div.attrs({
  className: "h-full w-full bg-[#C4C4C4] rounded-full",
})``;

export default {
  Card,
  CardContent,
  CardTitle,
  ButtonType,
  Border,
  Inside,
};
